import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDataScientist = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🧠 Recruter un Data Scientist
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Data Scientist est un expert de l’analyse de données massives. À la croisée des statistiques, de l’informatique et du business, il transforme les données brutes en insights utiles pour guider les décisions stratégiques de l’entreprise. Il est souvent au cœur des projets d’intelligence artificielle, de scoring client, ou encore de prévisions de marché.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Collecter, structurer et nettoyer de grands volumes de données</li>
          <li>Construire des modèles prédictifs (machine learning, deep learning)</li>
          <li>Interpréter les résultats et produire des visualisations claires</li>
          <li>Travailler en lien avec les équipes métiers pour orienter les analyses</li>
          <li>Veiller à la qualité et à la fiabilité des données utilisées</li>
          <li>Participer à la mise en production de modèles dans des environnements cloud</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Langages : Python, R, SQL</li>
          <li>Librairies : Pandas, Scikit-learn, TensorFlow, Keras</li>
          <li>Outils : Jupyter, Power BI, Tableau</li>
          <li>Connaissances en statistiques, modélisation, analyse exploratoire</li>
          <li>Bon esprit de synthèse et pédagogie pour vulgariser les résultats</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : diplômé en data ou statistiques, premières expériences en stage ou freelance</li>
          <li>Confirmé : 3–5 ans d’expérience sur des projets concrets en entreprise</li>
          <li>Senior / Expert : profil hybride avec forte valeur métier, capable de piloter une équipe ou un projet IA</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 300–400 € / jour</li>
          <li>Confirmé : 450–650 € / jour</li>
          <li>Senior : 700–900 € / jour, selon spécialisation et secteur</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDataScientist;
